import e, { OPTIONS as T } from "../../managers/braze-instance.js";
import ot from "../../util/browser-detector.js";
import {
  clickElement as Et,
  supportsPassive as Tt
} from "../../util/dom-utils.js";
import { KeyCodes as at } from "../../util/key-codes.js";
import u from "../../managers/subscription-manager.js";
export default class InAppMessage {
  constructor(
    t,
    s,
    i,
    e,
    h,
    n,
    r,
    o,
    l,
    E,
    T,
    a,
    m,
    c,
    I,
    A,
    N,
    _,
    L,
    d,
    O,
    S,
    D,
    M,
    R,
    b,
    P,
    p,
    C
  ) {
    (this.message = t),
      (this.messageAlignment = s || InAppMessage.TextAlignment.CENTER),
      (this.duration = E || 5e3),
      (this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM),
      (this.extras = e || {}),
      (this.triggerId = h),
      (this.clickAction = n || InAppMessage.ClickAction.NONE),
      (this.uri = r),
      (this.openTarget = o || InAppMessage.OpenTarget.NONE),
      (this.dismissType = l || InAppMessage.DismissType.AUTO_DISMISS),
      (this.icon = T),
      (this.imageUrl = a),
      (this.imageStyle = m || InAppMessage.ImageStyle.TOP),
      (this.iconColor = c || InAppMessage.Xi.Yi),
      (this.iconBackgroundColor = I || InAppMessage.Xi.Wi),
      (this.backgroundColor = A || InAppMessage.Xi.Yi),
      (this.textColor = N || InAppMessage.Xi.Zi),
      (this.closeButtonColor = _ || InAppMessage.Xi.th),
      (this.animateIn = L),
      null == this.animateIn && (this.animateIn = !0),
      (this.animateOut = d),
      null == this.animateOut && (this.animateOut = !0),
      (this.header = O),
      (this.headerAlignment = S || InAppMessage.TextAlignment.CENTER),
      (this.headerTextColor = D || InAppMessage.Xi.Zi),
      (this.frameColor = M || InAppMessage.Xi.sh),
      (this.buttons = R || []),
      (this.cropType = b || InAppMessage.CropType.FIT_CENTER),
      (this.orientation = P),
      (this.htmlId = p),
      (this.css = C),
      (this.isControl = !1),
      (this.ih = !1),
      (this.nl = !1),
      (this.eh = !1),
      (this.lt = new u()),
      (this.hh = new u());
  }
  subscribeToClickedEvent(t) {
    return this.lt.ut(t);
  }
  subscribeToDismissedEvent(t) {
    return this.hh.ut(t);
  }
  removeSubscription(t) {
    this.lt.removeSubscription(t), this.hh.removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.lt.removeAllSubscriptions(), this.hh.removeAllSubscriptions();
  }
  closeMessage() {
    this.he(this.qe);
  }
  xe() {
    return !0;
  }
  ll() {
    return this.xe();
  }
  Ee() {
    return null != this.htmlId && this.htmlId.length > 4;
  }
  ye() {
    return this.Ee() && null != this.css && this.css.length > 0;
  }
  Ae() {
    if (this.Ee() && this.ye()) return this.htmlId + "-css";
  }
  R() {
    return !this.ih && ((this.ih = !0), !0);
  }
  Cr() {
    return this.ih;
  }
  k() {
    return !this.nl && ((this.nl = !0), this.lt.St(), !0);
  }
  J() {
    return !this.eh && ((this.eh = !0), this.hh.St(), !0);
  }
  nh(t) {
    if (t && t.parentNode) {
      let s = t.closest(".ab-iam-root");
      if ((null == s && (s = t), this.xe() && null != s.parentNode)) {
        const t = s.parentNode.classList;
        t && t.contains(InAppMessage.rh) && t.remove(InAppMessage.rh),
          document.body.removeEventListener("touchmove", InAppMessage.oh);
      }
      s.className = s.className.replace(InAppMessage.lh, InAppMessage.Eh);
    }
    return this.animateOut;
  }
  he(t, s) {
    if (null == t) return;
    let i;
    (this.qe = null),
      (i =
        -1 === t.className.indexOf("ab-in-app-message")
          ? t.getElementsByClassName("ab-in-app-message")[0]
          : t);
    let e = !1;
    i && (e = this.nh(i));
    const h = document.body;
    if (null != h) var n = h.scrollTop;
    const r = () => {
      if (t && t.parentNode) {
        let s = t.closest(".ab-iam-root");
        null == s && (s = t), s.parentNode && s.parentNode.removeChild(s);
      }
      if (null != this.Ae()) {
        const t = document.getElementById(this.Ae());
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      null != h && "Safari" === ot.browser && (h.scrollTop = n),
        s ? s() : this.J();
    };
    e ? setTimeout(r, InAppMessage.uh) : r(), this.ke && this.ke.focus();
  }
  Be() {
    return document.createTextNode(this.message);
  }
  Ie(t) {
    let s = "";
    this.message || this.header || !this.xe() || (s = "Modal Image"),
      t.setAttribute("alt", s);
  }
  static oh(t) {
    (t.targetTouches && t.targetTouches.length > 1) ||
      (t.target.classList &&
        t.target.classList.contains("ab-message-text") &&
        t.target.scrollHeight > t.target.clientHeight) ||
      (document.querySelector(`.${InAppMessage.rh}`) && t.preventDefault());
  }
  Th(t) {
    this.xe() &&
      null != t.parentNode &&
      this.orientation !== InAppMessage.Orientation.LANDSCAPE &&
      (null != t.parentNode.classList &&
        t.parentNode.classList.add(InAppMessage.rh),
      document.body.addEventListener(
        "touchmove",
        InAppMessage.oh,
        !!Tt() && { passive: !1 }
      )),
      (t.className += " " + InAppMessage.lh);
  }
  static ah(t) {
    if (
      t.keyCode === at.mh &&
      !e.nn(T.Ih) &&
      document.querySelectorAll(".ab-modal-interactions").length > 0
    ) {
      const t = document.getElementsByClassName("ab-html-message");
      let s = !1;
      for (let i = 0; i < t.length; i++) {
        const e = t[i].contentWindow.document.getElementsByClassName(
          "ab-programmatic-close-button"
        )[0];
        null != e && (Et(e), (s = !0));
      }
      if (!s) {
        const t = document.querySelectorAll(
          ".ab-modal-interactions > .ab-close-button"
        )[0];
        null != t && Et(t);
      }
    }
  }
  Ah() {
    this.Nh ||
      e.nn(T.Ih) ||
      (document.addEventListener("keydown", InAppMessage.ah, !1),
      e._h(() => {
        document.removeEventListener("keydown", InAppMessage.ah);
      }),
      (this.Nh = !0));
  }
}
(InAppMessage.Xi = {
  Zi: 4281545523,
  Yi: 4294967295,
  Wi: 4278219733,
  Lh: 4293914607,
  dh: 4283782485,
  sh: 3224580915,
  th: 4288387995
}),
  (InAppMessage.Me = {
    Oh: "hd",
    ze: "ias",
    Sh: "of",
    Dh: "do",
    Li: "umt",
    Ri: "tf",
    Mh: "te"
  }),
  (InAppMessage.SlideFrom = { TOP: "TOP", BOTTOM: "BOTTOM" }),
  (InAppMessage.ClickAction = {
    NEWS_FEED: "NEWS_FEED",
    URI: "URI",
    NONE: "NONE"
  }),
  (InAppMessage.DismissType = {
    AUTO_DISMISS: "AUTO_DISMISS",
    MANUAL: "SWIPE"
  }),
  (InAppMessage.OpenTarget = { NONE: "NONE", BLANK: "BLANK" }),
  (InAppMessage.ImageStyle = { TOP: "TOP", GRAPHIC: "GRAPHIC" }),
  (InAppMessage.Orientation = { PORTRAIT: "PORTRAIT", LANDSCAPE: "LANDSCAPE" }),
  (InAppMessage.TextAlignment = {
    START: "START",
    CENTER: "CENTER",
    END: "END"
  }),
  (InAppMessage.CropType = {
    CENTER_CROP: "CENTER_CROP",
    FIT_CENTER: "FIT_CENTER"
  }),
  (InAppMessage.es = {
    Rh: "SLIDEUP",
    bh: "MODAL",
    Ne: "MODAL_STYLED",
    Tr: "FULL",
    ul: "WEB_HTML",
    Pe: "HTML"
  }),
  (InAppMessage.uh = 500),
  (InAppMessage.Ph = 200),
  (InAppMessage.lh = "ab-show"),
  (InAppMessage.Eh = "ab-hide"),
  (InAppMessage.rh = "ab-pause-scrolling");
